(function ($, njm) {
    'use strict';

    njm.views.modalSearchResults = Backbone.View.extend({

        events: {
        	//"click button": "submit"
		},
		
		initialize: function() {
			
			this.form = this.$("form.search-box");
			
			this.formField = this.$("#modal-search-query");
			
			this.regexPattern = this.formField.attr("data-val-regex-pattern");
			
			this.regex = new RegExp(this.regexPattern);
		
			this.regexErrorText = this.formField.attr("data-val-regex");
			
			this.requiredErrorText = this.formField.attr("data-val-required");
			
			this.errorEl = this.$("span.error");
			
			this.modalID = '#' + this.$el.parents('.custom-modal').attr('id');
			
			if (window.customModal) {
				window.customModal.modalSearchModalID = this.modalID;
			} else if (!window.customModal) {
				window.customModal = {};
				window.cusotmModal.modalSearchModalID = this.modalID;
			}
			
			window.customModal.setFocusableEls = function() {
				njm.views.customModal.prototype.setFocusableEls($(this.modalSearchModalID));
			}
			
			if (!window.modalSearch) {
				window.modalSearch = {};
			}
			
			// values to pass to the functions in the window object
			window.modalSearch.form = this.form;
			window.modalSearch.formField = this.formField;
			window.modalSearch.regex = this.regex;
			window.modalSearch.regexErrorText = this.regexErrorText;
			window.modalSearch.requiredErrorText = this.requiredErrorText;
			window.modalSearch.errorEl = this.errorEl;
			
			window.modalSearch.onBeginValidate = function() {
                window.modalSearch.submitValidation()
			}
			
            window.modalSearch.submitValidation = this.submitValidation;
			
			window.modalSearch.validate = this.validate;
			
			window.modalSearch.hideError = this.hideError;
			
            window.modalSearch.showError = this.showError;
            window.fnModalSearchPagination = this.fnModalSearchPagination;
			
		},

        fnModalSearchPagination: function (event) {
            if (event !== undefined) {               
                if (event.keyCode === 13) {
                    //If Page Input is less than 1 then default to 1. If page input greater than the total page count then default to totalpage count.  
                    var pageInput = $('.pageInput').val();
                    var totalPageCount = $("#TotalPageCount").val();
                    if (pageInput !== undefined && totalPageCount !== undefined) {
                        if (pageInput.length == 0||parseInt(pageInput) < 1) {
                            pageInput = 1
                        }
                        else if (parseInt(totalPageCount) < parseInt(pageInput)) {
                            pageInput = totalPageCount
                        }
                        $(".inputPage").attr('href', $(".inputPage").attr('href').replace("pageInput", pageInput));
                        $(".inputPage").click();
                    }
                }
            }
        },
        submitValidation: function() {
			
			var valid = this.validate();
			if (valid) {
                this.hideError();
                $("#resultContainer").show();
                return true;
			}
			if (this.formField.val().trim() === '') {
                this.showError();
                $("#resultContainer").hide();
			}
			
			return false;
		},
		
		validate: function() {
            var val = this.formField.val(),
                valid = this.regex.test(val);
			
			if (this.formField.val().trim() === '') {
				this.errorEl.text(this.requiredErrorText);
				this.form.removeClass('validated');
				return false;
			} else if (!valid) {
				this.errorEl.text(this.regexErrorText);
				this.form.addClass('validated');
                this.showError();
                $("#resultContainer").hide();
			}
			
			return valid;
			
		},
		
		hideError: function() {
			this.form.removeClass('haserror');
		},
		
		showError: function() {
			this.form.addClass('haserror');
		}
		
	});
})(jQuery, njm);
